"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockttpPluggableAdmin = exports.PluggableAdmin = exports.resetAdminServer = exports.MOCKTTP_PARAM_REF = exports.completionCheckers = exports.webSocketSteps = exports.requestSteps = exports.matchers = exports.RulePriority = exports.Method = void 0;
exports.getLocal = getLocal;
exports.getRemote = getRemote;
exports.getAdminServer = getAdminServer;
const mockttp_client_1 = require("./client/mockttp-client");
var types_1 = require("./types");
Object.defineProperty(exports, "Method", { enumerable: true, get: function () { return types_1.Method; } });
Object.defineProperty(exports, "RulePriority", { enumerable: true, get: function () { return types_1.RulePriority; } });
// Export rule data builders:
const matchers = require("./rules/matchers");
exports.matchers = matchers;
const requestStepDefinitions = require("./rules/requests/request-step-definitions");
exports.requestSteps = requestStepDefinitions;
const webSocketStepDefinitions = require("./rules/websockets/websocket-step-definitions");
exports.webSocketSteps = webSocketStepDefinitions;
const completionCheckers = require("./rules/completion-checkers");
exports.completionCheckers = completionCheckers;
var rule_parameters_1 = require("./rules/rule-parameters");
Object.defineProperty(exports, "MOCKTTP_PARAM_REF", { enumerable: true, get: function () { return rule_parameters_1.MOCKTTP_PARAM_REF; } });
// Export the core API:
function getLocal(options = {}) {
    return new mockttp_client_1.MockttpClient(options);
}
function getRemote(options = {}) {
    return new mockttp_client_1.MockttpClient(options);
}
function getAdminServer() {
    throw new Error('Cannot set up an admin server within a browser');
}
var admin_client_1 = require("./client/admin-client");
Object.defineProperty(exports, "resetAdminServer", { enumerable: true, get: function () { return admin_client_1.resetAdminServer; } });
exports.PluggableAdmin = require("./pluggable-admin-api/pluggable-admin");
exports.MockttpPluggableAdmin = require("./pluggable-admin-api/mockttp-pluggable-admin");
//# sourceMappingURL=main.browser.js.map